export default "__VITE_ASSET__dj5UUWS8__"